import React from 'react'
import './MagicalLoader.css'

interface MagicalLoaderProps {
  size?: number
  className?: string
}

const MagicalLoader: React.FC<MagicalLoaderProps> = ({ size = 100, className = '' }) => {
  return (
    <div className={`magical-loader ${className}`} style={{ width: size, height: size }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="magicGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#667eea" />
            <stop offset="50%" stopColor="#764ba2" />
            <stop offset="100%" stopColor="#f093fb" />
          </linearGradient>
          <filter id="glow">
            <feGaussianBlur stdDeviation="3" result="coloredBlur"/>
            <feMerge> 
              <feMergeNode in="coloredBlur"/>
              <feMergeNode in="SourceGraphic"/>
            </feMerge>
          </filter>
        </defs>
        
        {/* Central Crystal Ball */}
        <circle cx="50" cy="50" r="20" fill="url(#magicGradient)" filter="url(#glow)">
          <animate attributeName="r" values="18;22;18" dur="2s" repeatCount="indefinite" />
          <animate attributeName="opacity" values="0.7;1;0.7" dur="2s" repeatCount="indefinite" />
        </circle>
        
        {/* Inner Sparkle */}
        <circle cx="50" cy="50" r="12" fill="rgba(255,255,255,0.3)">
          <animate attributeName="r" values="10;14;10" dur="1.5s" repeatCount="indefinite" />
        </circle>
        
        {/* Orbiting Stars */}
        <g className="orbit-1">
          <circle cx="75" cy="50" r="3" fill="#ffd700">
            <animate attributeName="r" values="2;4;2" dur="1s" repeatCount="indefinite" />
          </circle>
          <animateTransform
            attributeName="transform"
            type="rotate"
            values="0 50 50;360 50 50"
            dur="3s"
            repeatCount="indefinite"
          />
        </g>
        
        <g className="orbit-2">
          <circle cx="25" cy="50" r="2" fill="#ff69b4">
            <animate attributeName="r" values="1.5;3;1.5" dur="1.2s" repeatCount="indefinite" />
          </circle>
          <animateTransform
            attributeName="transform"
            type="rotate"
            values="0 50 50;-360 50 50"
            dur="4s"
            repeatCount="indefinite"
          />
        </g>
        
        <g className="orbit-3">
          <circle cx="50" cy="25" r="2.5" fill="#00bfff">
            <animate attributeName="r" values="2;3.5;2" dur="0.8s" repeatCount="indefinite" />
          </circle>
          <animateTransform
            attributeName="transform"
            type="rotate"
            values="0 50 50;360 50 50"
            dur="2.5s"
            repeatCount="indefinite"
          />
        </g>
        
        <g className="orbit-4">
          <circle cx="50" cy="75" r="2" fill="#32cd32">
            <animate attributeName="r" values="1.8;3.2;1.8" dur="1.1s" repeatCount="indefinite" />
          </circle>
          <animateTransform
            attributeName="transform"
            type="rotate"
            values="0 50 50;-360 50 50"
            dur="3.5s"
            repeatCount="indefinite"
          />
        </g>
        
        {/* Random Sparkles */}
        <g className="sparkles">
          <polygon points="15,20 17,25 22,23 17,21" fill="#fff" opacity="0">
            <animate attributeName="opacity" values="0;1;0" dur="1.5s" repeatCount="indefinite" begin="0s" />
          </polygon>
          <polygon points="85,30 87,35 92,33 87,31" fill="#fff" opacity="0">
            <animate attributeName="opacity" values="0;1;0" dur="1.8s" repeatCount="indefinite" begin="0.5s" />
          </polygon>
          <polygon points="80,80 82,85 87,83 82,81" fill="#fff" opacity="0">
            <animate attributeName="opacity" values="0;1;0" dur="1.3s" repeatCount="indefinite" begin="1s" />
          </polygon>
          <polygon points="20,75 22,80 27,78 22,76" fill="#fff" opacity="0">
            <animate attributeName="opacity" values="0;1;0" dur="1.6s" repeatCount="indefinite" begin="1.5s" />
          </polygon>
        </g>
        
        {/* Magic Wand */}
        <g className="magic-wand">
          <line x1="10" y1="10" x2="25" y2="25" stroke="#8b4513" strokeWidth="2" strokeLinecap="round" />
          <polygon points="8,8 12,5 15,9 12,12" fill="#ffd700" />
          <animateTransform
            attributeName="transform"
            type="rotate"
            values="0 17.5 17.5;360 17.5 17.5"
            dur="5s"
            repeatCount="indefinite"
          />
        </g>
      </svg>
    </div>
  )
}

export default MagicalLoader
